<template>
    <div :class="{'alert': true, 'alert--error': props.type == 'error', 'alert--success': props.type == 'success'}" :style="props.style">
        <slot></slot>
    </div>
</template>

<script setup>
    const props = defineProps({
        type: { },
        style: {}
    })
</script>
<style>
@import url('./Alert.css');


</style>